import type { TFunction } from 'i18next';
import { PersonalInfoItems } from '~myAccount/enums';
import { Languages } from '~/constants/enums';
import personalInfoData from '~/data/personalInfo.json';

type PersonalInfoData = typeof personalInfoData;
type PersonalInfoDataKey = keyof PersonalInfoData;
type PersonalInfoItem = PersonalInfoData[PersonalInfoDataKey][number];

const personalInfoKeyMap: Record<PersonalInfoItems, PersonalInfoDataKey> = {
  [PersonalInfoItems.AGE]: 'age',
  [PersonalInfoItems.GENDER]: 'gender',
  [PersonalInfoItems.MARITAL_STATUS]: 'maritalStatus',
  [PersonalInfoItems.EDUCATION]: 'education',
  [PersonalInfoItems.INDUSTRY]: 'industry',
  [PersonalInfoItems.POSITION]: 'position',
  [PersonalInfoItems.PURCHASE_INFO]: 'purchaseInfo',
  [PersonalInfoItems.PURCHASE_PURPOSE]: 'purchase_purpose',
  [PersonalInfoItems.PURCHASE_FINANCING]: 'purchase_financing',
  [PersonalInfoItems.PURCHASE_TIME_FRAME]: 'purchase_timeframe',
};

const getPersonalInfo = (key: PersonalInfoItems): PersonalInfoItem[] => {
  return personalInfoData[personalInfoKeyMap[key]];
};

const getPersonalInfoTitle = (
  t: TFunction,
  locale: string,
  key: PersonalInfoItems,
  value: string | number | null | undefined,
): string => {
  const items = getPersonalInfo(key);

  if (value === null) return t('unAvailable');

  const item = items.find((element) => element.value === value);

  return locale === Languages.ARABIC
    ? (item?.title_ar ?? t('unAvailable'))
    : (item?.title ?? t('unAvailable'));
};

export { getPersonalInfoTitle, getPersonalInfo };
